import PortalIdParser from 'PortalIdParser';
import { CALL_TYPE_ID, EMAIL_TYPE_ID, MARKETING_EVENT_TYPE_ID, MEETING_EVENT_TYPE_ID, CAMPAIGN_TYPE_ID, QUOTE_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import enviro from 'enviro';
import { getFullUrl } from 'hubspot-url-utils';
import { getWindowLocation } from '../../common/utils/getWindowLocation';
export function getBaseUrl() {
  const subdomain = enviro.deployed() ? 'app' : 'local';
  return getFullUrl(subdomain); // app.hubspot.com/
}
export const getRecordPageHref = (objectTypeId, objectId, options) => {
  const location = getWindowLocation(options === null || options === void 0 ? void 0 : options.useParentLocation);
  const baseUrl = `${getBaseUrl()}/contacts/${PortalIdParser.get()}/record/${encodeURIComponent(objectTypeId)}/${encodeURIComponent(objectId)}`;
  const eschref = options !== null && options !== void 0 && options.includeEschref && location ? `?eschref=${encodeURIComponent(location.pathname + location.search)}` : '';
  return `${baseUrl}${eschref}`;
};
const SUPPORTED_NON_RECORD_PAGE_OBJECT_TYPES = {
  [CALL_TYPE_ID]: (portalId, objectId) => `/calls/${portalId}/review/${encodeURIComponent(objectId)}`,
  [EMAIL_TYPE_ID]: (portalId, objectId) => `/go-to/${portalId}/${EMAIL_TYPE_ID}/${encodeURIComponent(objectId)}`,
  [MARKETING_EVENT_TYPE_ID]: (portalId, objectId) => `/marketing-events/${portalId}/details/${encodeURIComponent(objectId)}`,
  [CAMPAIGN_TYPE_ID]: (portalId, objectId) => `/go-to/${portalId}/${CAMPAIGN_TYPE_ID}/${encodeURIComponent(objectId)}`,
  [QUOTE_TYPE_ID]: (portalId, objectId) => `/contacts/${portalId}/quote/${encodeURIComponent(objectId)}`,
  [MEETING_EVENT_TYPE_ID]: (portalId, objectId) => `/prospecting/${portalId}/meeting-execution/${encodeURIComponent(objectId)}`
};
export const isSupportedNonRecordPageObjectType = objectTypeId => {
  return Object.hasOwn ? Object.hasOwn(SUPPORTED_NON_RECORD_PAGE_OBJECT_TYPES, objectTypeId) : Object.prototype.hasOwnProperty.call(SUPPORTED_NON_RECORD_PAGE_OBJECT_TYPES, objectTypeId);
};
export const getNonRecordPageHref = (objectTypeId, objectId, options) => {
  const portalId = PortalIdParser.get();
  const getHref = SUPPORTED_NON_RECORD_PAGE_OBJECT_TYPES[objectTypeId];
  if (!getHref || !portalId) {
    return undefined;
  }
  const baseUrl = `${getBaseUrl()}${getHref(portalId, objectId)}`;
  const location = getWindowLocation(options === null || options === void 0 ? void 0 : options.useParentLocation);
  const eschref = options !== null && options !== void 0 && options.includeEschref && location ? `?eschref=${encodeURIComponent(location.pathname + location.search)}` : '';
  return `${baseUrl}${eschref}`;
};
export const getRecordHref = (objectTypeId, objectId, options) => {
  var _getNonRecordPageHref;
  return (_getNonRecordPageHref = getNonRecordPageHref(objectTypeId, objectId, options)) !== null && _getNonRecordPageHref !== void 0 ? _getNonRecordPageHref : getRecordPageHref(objectTypeId, objectId, options);
};
export const getAssociatedMeetingHref = objectId => {
  const portalId = PortalIdParser.get();
  const baseUrl = getBaseUrl();
  const href = `/go-to/${portalId}/${MEETING_EVENT_TYPE_ID}/${encodeURIComponent(objectId)}`;
  return `${baseUrl}${href}`;
};